import { QuizQuestion } from "../../shared/types";
import {
  AttachMoney,
  TrendingUp,
  Groups,
  Security,
  Person,
  People,
  Business,
  LocationCity,
  Cloud,
  HomeWork,
  Link,
  Storage,
  Speed,
  CloudSync,
  VpnLock,
  Smartphone,
  Computer,
  Block,
  HelpOutline,
  AutoFixHigh,
  Api,
  Build,
  CheckCircle,
  Timeline,
  Assignment,
  CreditCard,
  Diamond
} from "@mui/icons-material";

export const cloudQuestions: QuizQuestion[] = [
  {
    question: "What is your primary goal for moving to cloud solutions?",
    options: [
      { text: "Cost Reduction & Efficiency", icon: AttachMoney },
      { text: "Business Scalability", icon: TrendingUp },
      { text: "Remote Team Collaboration", icon: Groups },
      { text: "Enhanced Data Security", icon: Security }
    ]
  },
  {
    question: "How many users will need cloud access?",
    options: [
      { text: "1-10 users", icon: Person },
      { text: "11-50 users", icon: People },
      { text: "51-200 users", icon: Business },
      { text: "200+ users", icon: LocationCity }
    ]
  },
  {
    question: "What type of cloud deployment fits your needs?",
    options: [
      { text: "Public Cloud (AWS, Azure, GCP)", icon: Cloud },
      { text: "Private Cloud (Dedicated)", icon: HomeWork },
      { text: "Hybrid Cloud (Mix of both)", icon: Link },
      { text: "I'm not sure, recommend for me", icon: HelpOutline }
    ]
  },
  {
    question: "Which cloud services are most critical for your business?",
    options: [
      { text: "Data Storage & Backup", icon: Storage },
      { text: "Computing Power & Analytics", icon: Speed },
      { text: "Application Hosting & Development", icon: CloudSync },
      { text: "Security & Compliance Management", icon: VpnLock }
    ]
  },
  {
    question: "What's your monthly cloud budget range?",
    options: [
      { text: "$0 - $200/month", icon: AttachMoney },
      { text: "$201 - $800/month", icon: CreditCard },
      { text: "$801 - $2000/month", icon: TrendingUp },
      { text: "$2000+/month", icon: Diamond }
    ]
  },
  {
    question: "How important is mobile access for your team?",
    options: [
      { text: "Critical - Mobile-first workforce", icon: Smartphone },
      { text: "Important - Occasional mobile use", icon: Computer },
      { text: "Nice to have - Mostly desktop", icon: Block },
      { text: "Not sure about requirements", icon: HelpOutline }
    ]
  },
  {
    question: "What level of automation do you need?",
    options: [
      { text: "Full Automation (AI-driven)", icon: AutoFixHigh },
      { text: "Smart Automation (Rule-based)", icon: Api },
      { text: "Manual Control with Tools", icon: Build },
      { text: "Basic Setup Only", icon: CheckCircle }
    ]
  },
  {
    question: "What's your target implementation timeline?",
    options: [
      { text: "Immediate (1-4 weeks)", icon: Speed },
      { text: "Short term (1-3 months)", icon: Timeline },
      { text: "Medium term (3-6 months)", icon: Assignment },
      { text: "Long term (6+ months)", icon: Business }
    ]
  },
  {
    question: "What compliance requirements must you meet?",
    options: [
      { text: "GDPR/Data Protection", icon: VpnLock },
      { text: "Industry Specific (HIPAA, SOX, PCI)", icon: Security },
      { text: "General Business Compliance", icon: CheckCircle },
      { text: "No Specific Requirements", icon: Cloud }
    ]
  },
  {
    question: "What's your current IT infrastructure experience?",
    options: [
      { text: "Advanced - We have IT team", icon: Build },
      { text: "Intermediate - Some tech knowledge", icon: Computer },
      { text: "Basic - Need guidance", icon: HelpOutline },
      { text: "Beginner - Full managed service", icon: Groups }
    ]
  }
];